import { Component, EventEmitter, Input, Output } from '@angular/core';
import { humanize, placeholder } from '../utils/merge-tags';

/** Clickable chips for the allowed variables; emits the variable name to insert. */
@Component({
    selector: 'app-variable-chips',
    template: `
        <div class="variable-chips">
            <button *ngFor="let variable of variables" type="button" class="variable-chip"
                [disabled]="disabled" [matTooltip]="humanize(variable)" (click)="pick.emit(variable)">
                {{placeholder(variable)}}
            </button>
            <span *ngIf="!variables?.length" class="no-variables">This template has no variables.</span>
        </div>
    `,
    styles: [`
        .variable-chips { display: flex; flex-wrap: wrap; gap: 6px; }
        .variable-chip {
            padding: 2px 10px; border: 1px solid #c7d2fe; border-radius: 999px;
            background: #eef2ff; color: #3730a3; font-family: monospace; font-size: 12px; cursor: pointer;
        }
        .variable-chip:hover:not([disabled]) { background: #e0e7ff; }
        .variable-chip[disabled] { opacity: 0.5; cursor: default; }
        .no-variables { font-size: 12px; color: #6b7280; }
    `],
})
export class VariableChipsComponent {
    @Input() variables: string[] = [];
    @Input() disabled = false;
    @Output() pick = new EventEmitter<string>();

    humanize = humanize;
    placeholder = placeholder;
}
